import { isNumber } from "@bonusmap/shared_ui/library";
import { createChoicesInstance } from "../../utils/createChoicesInstance.js";
import { BaseWebComponent } from "../base-components/base-web-component.js";
import { ProfileDefRow } from "@bonusmap/api-types";

const { Choices } = window;

export class ProfileSelector extends BaseWebComponent {
    static override webComponentName: string = "profile-selector";
    protected override _templateId: string = "profile-selector";
// --------------------
    // elementi del componente
    // --------------------
    protected choicesInstance!: InstanceType<Window['Choices']>; // Choice.js instance
    protected listSelect!: HTMLSelectElement; // Select element for Choice.js
    constructor() {
        super();
    }
    
    protected _currentSelection: ProfileDefRow[] = []; // Current selected territorial result
    get currentSelection(): ProfileDefRow[] {
        return this._currentSelection;
    }
    protected set currentSelection(newSelection: ProfileDefRow[]) {
        this._currentSelection = newSelection;
    }
    
    protected  setGlobalListeners(): void {
    }

    protected  handleClearAll(e: Event): void {
        e.preventDefault();
        if (this.choicesInstance) {
            this.choicesInstance.clearStore();
            this.choicesInstance.clearChoices();
        }
        this._currentSelection = [];
    }

    protected  initializeChoices(): void {
        this.choicesInstance = createChoicesInstance(this.listSelect, {
            removeItemButton: true,
            searchEnabled: true,
            noResultsText: 'Nessun profilo trovato',
            noChoicesText: 'Digita almeno un carattere per cercare',
            searchPlaceholderValue: 'Digita per cercare il profilo...',
            singleModeForMultiSelect: true,
            maxItemCount: 1,
            duplicateItemsAllowed: false,
            closeDropdownOnSelect: true,
            callbackOnCreateTemplates: () => {
                return {
                    item: (config: any, choice: any, removeItemButton: any) => {
                        const originalItem = Choices.defaults.templates.item.call(
                            this.choicesInstance,
                            config,
                            choice,
                            removeItemButton
                        );
                        originalItem.classList.add('profile');
                        return originalItem;
                    }
                };
            }
        });

        this.listSelect.addEventListener('change', () => {
            this.syncSelectionFromChoices();
        });

        this.listSelect.addEventListener('addItem', () => {
            this.syncSelectionFromChoices();
        });

        this.listSelect.addEventListener('removeItem', () => {
            this.syncSelectionFromChoices();
        });

        this.listSelect.addEventListener('search', (event: any) => {
            const searchTerm = event.detail.value;
            this.performSearch(searchTerm);
        });
        // Carica i dati iniziali al focus se il dropdown è vuoto
        this.listSelect.addEventListener('showDropdown', (event: any) => {
            const currentSearchTerm = this.choicesInstance.input?.value || '';
            this.performSearch(currentSearchTerm);
        });
    }

    protected async performSearch(searchTerm: string): Promise<void> {
        if (!searchTerm || searchTerm.length === 0) {
            this.choicesInstance.clearChoices();
        }
        try {
            let whereClause = searchTerm && searchTerm.length > 0
                ? `last_name ILIKE $1 OR cod_fiscale ILIKE $1`
                : `1=1`; // Cerca tutti gli elementi se non c'è termine di ricerca
            let params = searchTerm && searchTerm.length > 0
                ? [`%${searchTerm}%`]
                : [];
            const result = await window.api.manager.profiles.query(whereClause, params, 'last_name', 20)
            if (result.success && result.data && result.data.length > 0) {
                const currentDataset = result.data;
                const choicesData = currentDataset.map(item => ({
                    value: item.id || '',
                    label: `${item.last_name} ${item.first_name} (${item.cod_fiscale || item.id})` || '',
                    customProperties: {
                        type: 'profile',
                        item
                    }
                }));

                this.choicesInstance.setChoices(choicesData, 'value', 'label', true);
            } else {
                this.choicesInstance.clearChoices();
            }
        } catch (error) {
            console.error('Error searching :', error);
            this.choicesInstance.clearChoices();
        }
    }

    protected  syncSelectionFromChoices(): void {
        const selectedValue = this.choicesInstance.getValue(true);
        if(isNumber(selectedValue)) {
            window.location.href = `/match/${selectedValue}`;
        }
    }

    protected valueChanged(newValue: string[]): void {
        console.log(newValue);
        // per ora non faccio nulla, gestito in afterRender
    }

    protected override afterRender(): void {
        this.listSelect = this.roleElementSelector("list-select") as HTMLSelectElement;
        this.initializeChoices();
        
    }

}
